export default "<template>\n  <div><FdSpinner /></div>\n</template>"